import { FileError } from "react-dropzone";

export interface JourneyStopPointData {
  stopPointId?: string | null;
  stopPointAlias?: string | null;
  stopPointAliasId?: string | null;
}

export interface JourneyPlace {
  Id?: number;
  PlaceName?: string;
  OgtType?: string;
  OgtStopPointData?: JourneyStopPointData | null;
}

export interface RouteLink {
  RouteLinkKey?: string;
  DepDateTime?: string;
  ArrDateTime?: string;
  From?: JourneyPlace;
  To?: JourneyPlace;

  Line: {
    LineName: string;
    LineNrReal?: number;
    LineTypeName: string;
    RunNo?: number;
    TrainNo?: number;
    OperatorId?: string;
    IsWalk?: boolean;

    Ogt: {
      OgtLineNamePreformatted?: string;
      OgtTrafficTypeGroupKey?: string;
      OgtTrafficTypeGroupCssClass: string;
      OgtTrafficTypeIconCssClass: string;
      OgtTrafficTypeIconReplaceLineName: boolean;
    };
  };
}

export interface SelectedJourney {
  fromName: string;
  toName: string;
  date: string;
  travelTime: string;
  journeyKey: string;
  line: RouteLink[];
  switches: number | string;
  unformattedDate: string;
  unformattedArrival?: string;
  UsedStartPlace?: JourneyPlace;
  UsedEndPlace?: JourneyPlace;
}

export interface FormModel {
  schoolorg: string;
  contactperson: string;
  phonenumberschoolorg: string;
  mailadress: string;
  journey: string;
  returnJourney: string;
  traveltype: string;
  SeatAvailabilityDisclaimer?: boolean;
  SelfResponsibility?: boolean;
  gdprAccept?: boolean;

  selectedJourney: SelectedJourney;
  selectedReturnJourney: SelectedJourney;

  //Test components:
  testpicker: string;
  filesuploadtest: UploadableFile[];
  textareatest: string;
  inputtest: string;
  radiotest: string;

  travelQty: string;
  phonenumber: string;
}

export interface UploadableFile {
  id: number;
  file: File;
  data: string;
  size: number;
  errors: FileError[];
}

export enum TimePeriod {
  Year,
  Month,
  Week,
  Day,
  Hour,
  Minute,
  Second,
  MilliSecond,
}

interface Stop {
  PlaceName: string;
  OgtType: string;
  Ll: [number, number];
  Id: number;
}

export interface TravelSearchModel {
  selectedJourneyFrom: Stop | null;
  selectedJourneyTo: Stop | null;
  journeyDate: string;
  journeyTime: string;
}

export interface TravelReturnSearchModel {
  selectedReturnJourneyFrom: Stop | null;
  selectedReturnJourneyTo: Stop | null;
  returnJourneyDate: string;
  returnJourneyTime: string;
}
